export { default } from './ShipmentContentsTablePSM'
